import axiosInstance from "../core/axios";
import { Create1099SummaryType } from "../types/genericType";
import { LoanType } from "../types/loanType";
import { apiEndPoints } from "../variables/apiEndpoints";

export const create1099Summary = async (body: Create1099SummaryType) => {
  try {
    const response = await axiosInstance.post(
      `${apiEndPoints.create1099Summary}`,
      {
        body,
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getLoanSummary = async (
  month: number,
  year: number
): Promise<LoanType[]> => {
  try {
    const response = await axiosInstance.get(`/${apiEndPoints.loanSummary}`, {
      params: {
        month,
        year,
      },
    });
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getInvestmentSummary = async (
  month: number,
  year: number
): Promise<LoanType[]> => {
  try {
    const response = await axiosInstance.get(
      `/${apiEndPoints.investmentSummary}`,
      {
        params: {
          month,
          year,
        },
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getOutOfBalance = async () => {
  try {
    const response = await axiosInstance.get(`/${apiEndPoints.getOutOfBalance}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getCashAccountStatement = async (beginningDate?: string,
  endingDate?: string) => {
  try {
    const response = await axiosInstance.get(`/${apiEndPoints.getCashAccountStatement}`, {
      params:{
        beginningDate,
        endingDate
      }
    });
    return response?.data;
  } catch (err) {
    throw err;
  }
};
